const getFullName = (user) => `${user.patientFirstName ?? user.firstName ?? ''} ${user.patientLastName ?? user.lastName ?? ''}`;

export default getFullName;
